import React, { FunctionComponent, ReactNode } from 'react';

import { Container, ContainerProps, Icon } from './styled';

export type ErrorMessageProps = ContainerProps & {
  children: ReactNode;
  hasIcon?: boolean;
};

const ErrorMessage: FunctionComponent<ErrorMessageProps> = ({
  children,
  hasIcon = false,
  size,
}) => {
  return (
    <Container size={size}>
      {hasIcon && <Icon />}
      {children}
    </Container>
  );
};

export default ErrorMessage;
